"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
const values = [{
  title: "ARCHIVES",
  text: "Digitizing colonial-era records, passenger manifests, and labor contracts to ensure they are never lost to time.",
  image: "https://images.unsplash.com/photo-1518546305927-5a555bb7020d?q=80&w=1200&auto=format&fit=crop",
  imageAlt: "Historical archives and documents, Girmitiya Council pillar"
}, {
  title: "EDUCATION",
  text: "Developing definitive historical resources and academic frameworks for studying the indentured diaspora.",
  image: "https://images.unsplash.com/photo-1457369804613-52c61a468e7d?q=80&w=1200&auto=format&fit=crop",
  imageAlt: "Open books and research materials, education pillar"
}, {
  title: "CULTURE",
  text: "Celebrating the unique synthesis of Indian heritage and local traditions born in the colonies.",
  image: "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?q=80&w=1200&auto=format&fit=crop",
  imageAlt: "Cultural heritage and traditions, culture pillar"
}, {
  title: "UNITY",
  text: "Connecting descendants across Fiji, Mauritius, the Caribbean, and beyond to foster a global community.",
  image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=1200&auto=format&fit=crop",
  imageAlt: "Coastal landscape symbolizing global diaspora unity"
}];
const AboutValues = () => {
  const $ = _c(6);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center justify-center gap-2 sm:gap-3 mb-4 sm:mb-6"><div className="w-8 h-px bg-[#DF6D2A]" /><span className="font-body text-[10.5px] tracking-[0.25em] uppercase text-[#DF6D2A] font-light">Our Core Pillars</span><div className="w-8 h-px bg-[#DF6D2A]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="max-w-[1280px] mx-auto px-4 sm:px-6 md:px-8 relative z-20 mb-12 sm:mb-16 md:mb-20 text-center">{t0}<h2 className="font-display text-[34px] sm:text-[44px] md:text-[56px] font-light text-[#F4EFE6] leading-[1.05]">The Foundation of our <em className="text-[#C9A84C] italic">Work</em></h2></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hoveredIndex) {
    t2 = values.map((item, index) => {
      const isHovered = hoveredIndex === index;
      return <div key={index} onMouseEnter={() => setHoveredIndex(index)} onMouseLeave={() => setHoveredIndex(null)} onClick={() => setHoveredIndex(hoveredIndex === index ? null : index)} className="group relative border-b border-white/10 cursor-pointer overflow-hidden"><div role="img" aria-label={item.imageAlt} className={`absolute inset-0 bg-cover bg-center transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] z-0 origin-left ${isHovered ? "scale-x-100 opacity-40 grayscale-0" : "scale-x-0 opacity-0 grayscale"}`} style={{
          backgroundImage: `url(${item.image})`
        }} /><div className="absolute inset-0 bg-gradient-to-r from-[#0F1C2E] via-[#0F1C2E]/60 to-transparent opacity-80 z-0" /><div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between px-4 sm:px-6 md:px-16 py-6 sm:py-8 md:py-12 lg:py-16 gap-4 sm:gap-6 md:gap-8"><div className="flex items-center gap-4 sm:gap-6 md:gap-8 lg:gap-16"><span className={`font-body text-[12px] sm:text-[14px] font-light tracking-[0.15em] sm:tracking-[0.2em] transition-colors duration-500 ${isHovered ? "text-[#C9A84C]" : "text-white/30"}`}>0{index + 1}</span><h3 className={`font-display text-[32px] sm:text-[48px] md:text-[64px] lg:text-[80px] xl:text-[100px] leading-none transition-all duration-500 tracking-tight ${isHovered ? "text-[#F4EFE6] italic" : "text-transparent [-webkit-text-stroke:1px_rgba(244,239,230,0.3)]"}`}>{item.title}</h3></div><div className="md:w-1/3 flex justify-end"><div className={`overflow-hidden transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] ${isHovered ? "max-h-[200px] opacity-100 translate-y-0" : "max-h-0 opacity-0 translate-y-8 md:max-h-full md:opacity-0 md:translate-y-4"}`}><p className="font-body text-[14px] sm:text-[15px] md:text-[16px] font-light text-[#F4EFE6] leading-[1.6] sm:leading-[1.7] md:text-right">{item.text}</p></div></div></div></div>;
    });
    $[2] = hoveredIndex;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <section className="bg-[#0F1C2E] py-16 sm:py-24 md:py-32 lg:py-48 relative overflow-hidden">{t1}<div className="w-full flex flex-col border-t border-white/10 relative z-20">{t2}</div></section>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default AboutValues;